import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class SessionsService {

  private sessionsObj = new BehaviorSubject<any[]>([]);
  public sessions = this.sessionsObj.asObservable();

  constructor(private http: HttpClient) { }

  getSessionsSaved() {
    return this.sessionsObj.getValue();
  }

  setSessionsSaved(sessions: any[]) {
    this.sessionsObj.next(sessions);
  }

  addSession(session: any) {
    const currentSessions = this.sessionsObj.getValue();
    this.sessionsObj.next([...currentSessions, session]);
  }

  clearSessions() {
    this.sessionsObj.next([]);
  }

  updateSessionInObservable(index: number, updatedSession: any) {
    const currentSessions = this.sessionsObj.getValue();
    const newSessions = [...currentSessions];
    newSessions[index] = updatedSession;
    this.sessionsObj.next(newSessions);
  }

  deleteSessionFromObservable(index: number) {
    const currentSessions = this.sessionsObj.getValue();
    const newSessions = currentSessions.filter((_, i) => i !== index);
    this.sessionsObj.next(newSessions);
  }

  findSessionIndexInObservable(session: any): number {
    const currentSessions = this.sessionsObj.getValue();
    return currentSessions.findIndex(s =>
      s.start_date === session.start_date &&
      s._isTemporary === true
    );
  }

  getNextSession(event: any) {
    event.sessions.sort((a: any, b: any) => {
      return new Date(a.start_date).getTime() - new Date(b.start_date).getTime();
    });
    const nextSession = event.sessions.find((session: any) => new Date(session.start_date) >= new Date());
    return nextSession;
  }

  updateSessionById(payload: any, idSession: number) {
    const url = `${AppSettings.API_URI_V2}/sessions/${idSession}`;
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      }), catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Actualiza todas las sesiones de un evento
  updateSessionsEvent(sessions: any, idEvent: number) {
    const url = `${AppSettings.API_URI_V2}/events/${idEvent}/sessions`;
    return this.http.put<any>(url, sessions).pipe(
      map(data => {
        return data;
      }), catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Crea múltiples sesiones para un evento
  createSessionsEvent(sessions: any[], idEvent: number) {
    const url = `${AppSettings.API_URI_V2}/events/${idEvent}/sessions`;
    const payload = { sessions };
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      }), catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Crea una nueva session
  createSession(sessionData: any) {
    const url = `${AppSettings.API_URI_V2}/sessions`;
    return this.http.post<any>(url, sessionData).pipe(
      map(data => {
        return data;
      }), catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Borra una sesion especifica de un evento
  deleteSession(idSession: number, idEvent: number) {
    const url = `${AppSettings.API_URI_V2}/sessions/${idSession}/events/${idEvent}`;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Crear sesiones recurrentes
  createRecurringSessions(payload: any, idEvent: number) {
    const url = `${AppSettings.API_URI_V2}/events/${idEvent}/sessions`;
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      }), catchError(error => {
        return throwError(() => error);
      })
    );
  }

  // Activa o desactiva una sesión específica sin afectar al resto del evento
  toggleSessionActive(idSession: number, active: boolean) {
    const url = `${AppSettings.API_URI_V2}/sessions/${idSession}/active`;
    return this.http.patch<any>(url, { active }).pipe(
      map(data => {
        return data;
      }), catchError(error => {
        return throwError(() => error);
      })
    );
  }
}
